import { render } from "./typing-faster.vue?vue&type=template&id=8ded5be8"
import script from "./typing-faster.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./typing-faster.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "/home/th3g3ntl3man/github/blog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__